import { render, staticRenderFns } from "./CategoriesSelectionPopup.vue?vue&type=template&id=45115859"
import script from "./CategoriesSelectionPopup.vue?vue&type=script&lang=js"
export * from "./CategoriesSelectionPopup.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSelectionPopup.vue?vue&type=style&index=0&id=45115859&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports